import useApiHelpers from "./helpers";
import { useGlobalStore } from "@/stores/globalStore";

const { getRequest } = useApiHelpers();

export default function useCustomerActions() {
  const globalStore = useGlobalStore();

  const fetchCustomerId = async () => {
    const res = await getRequest("/customerId");
    globalStore.setCustomerId(res.data.customerId);
    return res.data.customerId;
  };

  const fetchCustomerKycSharingInfo = async () => {
    const res = await getRequest("/getKycSharingPersonalDetails");
    return res.data;
  };

  const fetchCustomerAccountInfo = async () => {
    const res = await getRequest("/getCustomerAccountInfo");
    return res.data;
  };

  const fillForm = async (formValues, form, store) => {
    const values = Object.entries(formValues);
    values.forEach(([key, value]) => {
      if (store.form[key]) {
        store.form[key].value = value;
        form.value[key] = value;
      }
    });
  };

  return {
    fetchCustomerId,
    fetchCustomerAccountInfo,
    fetchCustomerKycSharingInfo,
    fillForm,
  };
}
